<template>
  <div class="wrapper">
    <div class="section page-header" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-100 text-center">
            <h1 class="title-white">{{ $t("system.header_title") }}</h1>
          </div>
        </div>
        <div v-if="isMobileDevice" class="md-layout margin-top-64">
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.time") }}<br />2019-{{ currentYear }}
            </h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.role") }}<br />Lead Design, System Design
            </h4>
          </div>
          <div class="md-layout-item md-size-100 text-center">
            <h4 class="subtitle">
              {{ $t("common.platform") }}<br />Mobile, Desktop, Console
            </h4>
          </div>
        </div>
        <div v-else class="md-layout margin-top-64">
          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">{{ $t("common.time") }}<br />2019-2021</h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.role") }}<br />Lead Design, System Design
              </h4>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 text-center">
              <h4 class="subtitle">
                {{ $t("common.platform") }}<br />Mobile, Desktop, Console
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="large-section">
        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("system.project.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("system.project.description1") }}
                </h4>
                <h4 class="content text-left">
                  {{ $t("system.project.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="project" />
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("system.challenges.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("system.challenges.description1") }}
                </h4>
                <h4 class="content text-left">
                  {{ $t("system.challenges.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="challenges" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section" :style="visionBackgroundStyle">
        <div class="container vision-margin">
          <div class="md-layout">
            <div class="md-layout-item md-size-60 md-small-size-100">
              <div>
                <h3 class="description">{{ $t("system.vision.title") }}</h3>
                <h1 class="title-white text-left">
                  {{ $t("system.vision.description") }}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="large-section">
        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">{{ $t("system.design.title") }}</h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("system.design.description") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="design" />
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <div class="video-container" @click="goToFramer()">
                  <img :src="design_video_background" />
                  <video playsinline autoplay muted loop>
                    <source :src="design_video_1" type="video/mp4" />
                    Your browser does not support the video mp4 type, please use
                    latest Chrome or Safari
                  </video>
                </div>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <video playsinline autoplay muted loop>
                  <source :src="design_video_2" type="video/mp4" />
                  Your browser does not support the video mp4 type, please use
                  latest Chrome or Safari
                </video>
              </div>
            </div>
          </div>
        </div>

        <div class="section">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title text-left">
                  {{ $t("system.process.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content text-left">
                  {{ $t("system.process.description") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="process" :large="process_large" preview="0" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="large-section large-section-black">
        <div class="section section-black">
          <div class="container">
            <div class="md-layout">
              <div class="md-layout-item md-size-45 md-small-size-100">
                <h2 class="title title-white text-left">
                  {{ $t("system.outcome.title") }}
                </h2>
              </div>
              <div class="md-layout-item md-size-55 md-small-size-100">
                <h4 class="content-white text-left">
                  {{ $t("system.outcome.description1") }}
                </h4>
                <h4 class="content-white text-left">
                  {{ $t("system.outcome.description2") }}
                </h4>
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="outcomes[0].image" />
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="outcomes[1].image" />
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <img :src="outcomes[2].image" />
              </div>
            </div>
            <div class="md-layout section-internal-padding">
              <div class="md-layout-item md-size-100 md-small-size-100">
                <video playsinline autoplay muted loop>
                  <source :src="outcome_video" type="video/mp4" />
                  Your browser does not support the video mp4 type, please use
                  latest Chrome or Safari
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- main-->
  </div>
  <!-- wrapper-->
</template>

<script>
export default {
  bodyClass: "uiblox-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/system/background.png")
    },
    project: {
      type: String,
      default: require("@/assets/img/system/project.png")
    },
    challenges: {
      type: String,
      default: require("@/assets/img/system/challenges.gif")
    },
    vision_background: {
      type: String,
      default: require("@/assets/img/system/vision_background.png")
    },
    process: {
      type: String,
      default: require("@/assets/img/system/process.png")
    },
    process_large: {
      type: String,
      default: require("@/assets/img/system/process_large.png")
    },
    design: {
      type: String,
      default: require("@/assets/img/system/design.png")
    },
    design_video_1: {
      type: String,
      default: require("@/assets/video/design_video_1.mp4")
    },
    design_video_2: {
      type: String,
      default: require("@/assets/video/design_video_2.mp4")
    },
    design_video_background: {
      type: String,
      default: require("@/assets/img/system/design_video_background.png")
    },
    outcome_video: {
      type: String,
      default: require("@/assets/video/outcome_video.mp4")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      currentYear: new Date().getFullYear(),
      outcomes: [
        { image: require("@/assets/img/system/outcome_1.png") },
        { image: require("@/assets/img/system/outcome_2.gif") },
        { image: require("@/assets/img/system/outcome_3.gif") }
      ]
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
        backgroundSize: `cover`
      };
    },
    visionBackgroundStyle() {
      return {
        backgroundImage: `linear-gradient(88.49deg, rgba(0, 0, 0, 0.83) 21.94%, rgba(0, 0, 0, 0.625417) 37.81%, rgba(0, 0, 0, 0) 91.18%),url(${this.vision_background})`,
        backgroundSize: `cover`
      };
    }
  },
  methods: {
    goToFramer() {
      window.open("https://framer.cloud/TfHpY", "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.vision-margin {
  margin-top: 12rem;
  margin-bottom: 12rem;
}
.video-container {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 500;
  cursor: pointer;
}
.video-container video {
  position: absolute;
  width: 78%;
  height: 78%;
  left: 12%;
  top: 10%;
  z-index: 600;
}
video {
  z-index: 1;
}
</style>
